import { getUserLevelsAccess } from "@modules/user/data";

export const getUserData = async ({ setData, setStatus }) => {
	setStatus("loading");
	let { uid, email, fName, lName, isAdmin } = _.config.Item("userInfo");
	let levels = await getUserLevelsAccess();
	setData((prevState) => ({ ...prevState, isAdmin: isAdmin ? true : false, uid, email, fName, lName, levels }));
	setStatus("success");
};
